import fs from 'node:fs'
import path from 'node:path'
import { resolveCliAssetPath } from '@core-engine/utils/cli-root.js'
import type { BetterstartPresetId } from '@preset-engine/types.js'

export function presetTemplateRoot(presetId: BetterstartPresetId): string {
  return resolveCliAssetPath('adapters', 'next', 'presets', presetId)
}

export function readPresetTemplate(presetId: BetterstartPresetId, relativePath: string): string {
  return fs.readFileSync(path.join(presetTemplateRoot(presetId), relativePath), 'utf-8')
}

export function listPresetSchemaTemplatePaths(presetId: BetterstartPresetId): string[] {
  const schemasDir = path.join(presetTemplateRoot(presetId), 'schemas')
  if (!fs.existsSync(schemasDir)) {
    return []
  }

  return fs
    .readdirSync(schemasDir)
    .filter((entry) => entry.endsWith('.json'))
    .sort()
}
